import React from "react";

/**
 * R6 B6 — Overdue Heatmap (reps × day of week).
 */
export default function OverdueHeatmap({ days = [], rows = [], onDrill }) {
  const max = rows.reduce((m, r) => Math.max(m, ...(r.days || [0])), 0) || 1;
  const header = days.length ? days : ["Mon", "Tue", "Wed", "Thu", "Fri", "Sat", "Sun"];

  return (
    <div className="r6-analytics-block">
      <h3 className="r6-analytics-title">Overdue Heatmap</h3>
      <div className="r6-analytics-table-wrap">
        <table className="r6-analytics-table r6-heatmap">
          <thead>
            <tr>
              <th>Rep</th>
              {header.map((d) => <th key={d}>{d}</th>)}
            </tr>
          </thead>
          <tbody>
            {rows.length === 0 && (
              <tr><td colSpan={8} className="r6-analytics-empty">No data</td></tr>
            )}
            {rows.map((r) => (
              <tr key={r.rep_id}>
                <td>{r.rep_name}</td>
                {(r.days || []).map((n, i) => (
                  <td
                    key={i}
                    className="r6-heatmap-cell r6-analytics-clickable"
                    style={{ background: `rgba(217,119,6,${(n / max) * 0.6})` }}
                    onClick={() => onDrill?.({ salesRep: r.rep_id, nextContact: "past_due" })}
                  >
                    {n || 0}
                  </td>
                ))}
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}